import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

export default {
	state: {},
	mutations: {},
	actions: {
		async getHomeReport() {
			return new Promise((resolve) => {
				Vue.prototype.$http.get("report/home").then((response) => {
					resolve(response.data.data);
				});
			}).catch((err) => {
				console.error(err);
			});
		},
		getExtractUserList() {
			this.state.loading = true;
			Vue.prototype.$http
				.download("report/extract/users")
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.userList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractRequirementList(_, isSystemOnly) {
			this.state.loading = true;
			Vue.prototype.$http
				.download(`report/extract/requirements${isSystemOnly ? "/system" : ""}`)
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.requirementList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractInviteListFiltered(_, inviteList) {
			this.state.loading = true;
			Vue.prototype.$http
				.postDownload("report/extract/inviteListFiltered", inviteList)
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.inviteList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractOfferListFiltered(_, offersIds) {
			this.state.loading = true;
			Vue.prototype.$http
				.postDownload("report/extract/offerListFiltered", offersIds)
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.offerList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractClientListBySupplier(_, filter) {
			this.state.loading = true;
			Vue.prototype.$http
				.postDownload("report/extract/clients", filter)
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.clientList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractVendorList(_, filter) {
			this.state.loading = true;
			Vue.prototype.$http
				.postDownload("report/extract/vendorList", filter)
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.supplierList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractMaskList() {
			this.state.loading = true;
			Vue.prototype.$http
				.download("report/extract/maskList")
				.then((response) => {
					this.state.loading = false;
					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");

					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.maskList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		},
		getExtractBlackList() {
			this.state.loading = true;
			Vue.prototype.$http
				.download("report/extract/blacklisteds")
				.then((response) => {
					this.state.loading = false;

					if (response.data.error) {
						Vue.prototype.$functions.displayError(this._vm, response.data.error);
						return;
					}

					var fURL = document.createElement("a");
					fURL.href = window.URL.createObjectURL(new Blob([response.data]));
					fURL.setAttribute("download", i18n.t("commons.report.blacklistList") + ".xlsx");
					document.body.appendChild(fURL);

					fURL.click();
				})
				.catch((error) => {
					console.error(error);
					this.state.loading = false;
				});
		}
	},
	getters: {}
};
